import { render } from "./BarChartRight.vue?vue&type=template&id=591a1250"
import script from "./BarChartRight.vue?vue&type=script&lang=ts"
export * from "./BarChartRight.vue?vue&type=script&lang=ts"
script.render = render

export default script